<template>
  <div class="multiselect filter-form-box" ref="select-box">
    <div class="selectBox activity-type-select d-flex justify-content-between align-items-center truncate pl-5 pr-5" :class="add_button ? 'w-200' : ''" v-if="value && value.length">
      <span v-if="selectAllFlag" class="d-inline-block truncate selected-filter" @click="openDropdown"> {{ "Multiple selected" }}</span>
      <span v-else class="d-inline-block truncate selected-filter" @click="openDropdown">{{ selectedValuesString }}</span>
      <span class="d-inline-block clear-filter-contianer" @click="clearFilter">
        <span class="clear-filter">x</span>
      </span>
    </div>
    <div class="selectBox" :class="add_button ? 'w-200' : ''" @click="openDropdown" v-else>
      <select class="activity-type-select" :class="add_button ? 'medicationdropdown' : ''">
        <option value>{{ title }}</option>
      </select>
      <div class="overSelect"></div>
    </div>
    <div ref="options" class="select-scroll activity-builder-select-options" :class="add_button ? 'w-200' : ''" v-if="isDisplayOptions" :style="{ width: width }">
      <div class="check_label_input d-flex" :class="separatefirstchild ? 'fixflagclass' : ''">
        <input v-if="select_all_button" v-model="selectAllFlag" type="checkbox" @change="selectAllDose($event)" />
        <label>{{ select_button_text }}</label>
      </div>
      <div class="check_label_input d-flex" :class="separatefirstchild ? 'fixflagclass' : ''" v-for="option in options" :key="option.id">
        <input type="checkbox" @change="toggleOptionSelection(option)" :checked="isChecked(option.id)" />
        <label>{{ option[field] }}</label>
      </div>
      <hr class="mb-10 mt-3" v-if="add_button" />
      <span role="button" class="add-more-button text-center color_blue" @click="addMore()" v-if="add_button">+ {{ button_text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "activity-library-select",

  data() {
    return {
      isDisplayOptions: false,
      selectAllFlag: false
    };
  },

  props: {
    options: {
      type: Array
    },
    separatefirstchild: {},
    title: {},
    value: {
      default: () => []
    },
    field: {},
    singleSelection: { default: false },
    width: {
      default: "auto"
    },
    add_button: { type: Boolean, default: false },
    button_text: { type: String, default: "" },
    select_all_button: { type: String, default: "" },
    select_button_text: { type: String, default: "" }
  },

  computed: {
    selectedValuesString() {
      if (this.singleSelection) {
        return this.value;
      }
      if (this.value && this.value.length) {
        let selectedValuesString = "";
        this.value.forEach(item => (selectedValuesString += " " + item[this.field]));
        return selectedValuesString;
      }
      return "";
    }
  },

  methods: {
    onSelect(option) {
      this.$emit("onSelect", option);
      this.$emit("input", option);
    },
    openDropdown() {
      this.isDisplayOptions = true;
    },

    closeDropdown() {
      this.isDisplayOptions = false;
    },

    toggleOptionSelection(option) {
      if (this.singleSelection) {
        this.$emit("input", option.id);
        this.$emit("onChange", option.id);
        this.isDisplayOptions = false;
        return;
      }

      const optionIndex = this.value.findIndex(element => element.id === option.id);
      if (optionIndex === -1) {
        this.value.push(option);
      } else {
        this.value.splice(optionIndex, 1);
        this.selectAllFlag = false;
      }
      if (this.value.length == this.options.length) {
        this.selectAllFlag = true;
      }
      this.$emit("onChange", option);
    },

    addEventListenerForHidingDropdown() {
      document.addEventListener("click", event => {
        if (this.$refs["select-box"] && this.$refs["select-box"].contains(event.target)) {
        } else {
          this.isDisplayOptions = false;
        }
      });
    },

    isChecked(id) {
      if (this.singleSelection) {
        return this.value == id;
      }
      return this.value.findIndex(e => e.id === id) > -1;
    },

    clearFilter() {
      if (this.singleSelection) {
        this.$emit("input", "");
        this.$emit("onChange", "");
        this.isDisplayOptions = false;
        return;
      }
      this.$emit("input", []);
      this.$emit("onChange", []);
      this.selectAllFlag = false;
    },
    addMore() {
      this.$root.$emit("bv::show::modal", "modal-prevent-closing", "#btnShow");
    },
    selectAllDose(event) {
      this.options.forEach(option => {
        if (!this.value.some(dose => dose.value === option.value) && event.target.checked) {
          this.selectAllFlag = true;
          this.value.push(option);
        } else if (!event.target.checked) {
          this.selectAllFlag = false;
          this.$emit("clearFilterValue", []);
        }
      });
    }
  },

  mounted() {
    this.addEventListenerForHidingDropdown();
  }
};
</script>

<style scoped>
.filter-form-box .activity-type-select {
  width: 100%;
  font-size: 12px;
  border: none;
  height: 35px;
  border-radius: 3px;
  background-color: #ffff;
  color: #666669;
}

.selectBox {
  position: relative;
}

.selectBox select {
  width: 100%;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.activity-builder-select-options {
  background: #fff;
  position: absolute;
  width: auto;
  border-radius: 3px;
  padding: 10px 10px 0 10px;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  overflow: scroll;
  max-height: 420px;
  top: 32px;
}

.check_label_input input {
  margin-top: 0px;
  -webkit-margin-before: 8px;
  cursor: pointer;
}

.activity-builder-select-options label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  line-height: 30px;
  white-space: nowrap;
  margin-bottom: 0;
}

.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px;
  /* width of the entire scrollbar */
}

.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent;
  /* color of the tracking area */
}

.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9;
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 3px solid transparent;
  /* creates padding around scroll thumb */
}

.select-scroll {
  scrollbar-width: thin;
  /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent;
  /* scroll thumb & track */
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(90%);
}

.selected-filter {
  color: #4c8ce4;
  width: 80%;
  cursor: pointer;
}

.clear-filter-contianer {
  width: 20%;
}

.clear-filter {
  width: 14px;
  height: 14px;
  background-color: #4c8ce4;
  color: #ffffff;
  border-radius: 7px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  line-height: 12px;
}

.fixflagclass:first-child {
  border-bottom: 1px solid #b0bac9;
  margin-bottom: 8px;
  padding-bottom: 6px;
}

.add-more-button {
  position: relative;
  left: 25%;
  bottom: 0;
  width: 100%;
}

.activity-type-select.medicationdropdown {
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down-dark.png);
  padding: 0.5em;
  padding-right: 1.5em;
}
</style>
